import { gql } from "@apollo/client";

export interface BootstrapExtensionCandidate {
  iccid: string;
  vehicleId: string;
  ready: boolean;
  missing: string[];
}

export interface BootstrapExtensionCandidatesData {
  bootstrapExtensionCandidates: {
    candidates: BootstrapExtensionCandidate[];
    total: number;
  };
}

export interface BootstrapExtensionResult {
  success: boolean;
  message: string;
  raised: number;
  failed: number;
  skipped: number;
}

export interface TriggerBootstrapExtensionData {
  triggerBootstrapExtension: BootstrapExtensionResult;
}

export const GET_BOOTSTRAP_EXTENSION_CANDIDATES = gql`
  query BootstrapExtensionCandidates {
    bootstrapExtensionCandidates {
      total
      candidates {
        iccid
        vehicleId
        ready
        missing
      }
    }
  }
`;

export const TRIGGER_BOOTSTRAP_EXTENSION = gql`
  mutation TriggerBootstrapExtension($iccid: String!) {
    triggerBootstrapExtension(iccid: $iccid) {
      success
      message
      raised
      failed
      skipped
    }
  }
`;
